import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const Container = styled.div`
  background-color: #1e2528;
  .img {
    padding: 36px;
  }
  .font {
  }
  .control {
    margin-top: 2rem;
  }
  .pos:hover {
    color: red;
  }
  .copy {
    margin-top: 8rem;
  }
  .toper {
    margin-top: 2rem;
  }
  .icon {
    color: white;
  }
  li {
    margin-top: 0.5rem;
  }
`;
const Footer = () => (
  <Container className="foot">
    <section className="section">
      <div className="container">
        <div className="columns">
          <div className="column">
            <div>
              <h1 className="font  is-size-4 has-text-white has-text-weight-bold">
                Useful link
              </h1>
              <ul className="toper has-text-grey is-size-6 has-text-weight-semibold ">
                <li>
                  <Link to="/about">About</Link>{' '}
                </li>
                <li>
                  <Link to="/blog">Blog</Link>{' '}
                </li>
                <li>
                  <Link to="/service">Services</Link>{' '}
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>{' '}
                </li>
              </ul>
            </div>
          </div>
          <div className="column">
            <div>
              <h1 className="font  is-size-4 has-text-white has-text-weight-bold">
                CONTACT INFO
              </h1>
              <ul className="toper has-text-grey is-size-6 has-text-weight-semibold ">
                <li>
                  4361 Morningview Lane Artland ,
                  <span>Pall Street Latimer, IA 50452 / 23654</span>
                </li>
                <li>+02 - 32 365 2654</li>
                <li>+02 - 32 365 2654</li>
                <li>ariclawyerfirm.com</li>
              </ul>
            </div>
          </div>
          <div className="column">
            <div>
              <h1 className="font  is-size-4 has-text-white has-text-weight-bold">
                INSTAGRAM
              </h1>
              <div className="columns img">
                <div className="column">
                  <img
                    src="https://colorlib.com/preview/theme/shotgear/img/footer_img/footer_img_1.png"
                    alt=""
                  />
                  <img
                    src="https://colorlib.com/preview/theme/shotgear/img/footer_img/footer_img_5.png"
                    alt=""
                  />
                </div>
                <div className="column">
                  <img
                    src="https://colorlib.com/preview/theme/shotgear/img/footer_img/footer_img_2.png"
                    alt=""
                  />
                  <img
                    src="https://colorlib.com/preview/theme/shotgear/img/footer_img/footer_img_6.png"
                    alt=""
                  />
                </div>
                <div className="column">
                  <img
                    src="https://colorlib.com/preview/theme/shotgear/img/footer_img/footer_img_3.png"
                    alt=""
                  />
                  <img
                    src="https://colorlib.com/preview/theme/shotgear/img/footer_img/footer_img_4.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            <div>
              <h1 className="font  is-size-4 has-text-white has-text-weight-bold">
                NEWSLETTER
              </h1>
              <ul className=" toper has-text-grey is-size-6 has-text-weight-semibold  ">
                <p>
                  Stay updated with our latest trends see heaven so said place
                  fruit.
                </p>
              </ul>
              <div className="field has-addons">
                <div className="control">
                  <input
                    className="input"
                    type="text"
                    placeholder="Your Email Address"
                  />
                </div>
                <div className="control">
                  <a className="button is-danger">Submit</a>
                </div>
              </div>
              <a href="https://www.facebook.com/theejohndoe">
                <span className="icon ">
                  <i className="fab fa-facebook-f" />
                </span>
              </a>
              <a href="/">
                <span className="icon ">
                  <i className="fab fa-twitter" />
                </span>{' '}
              </a>

              <a href="/">
                <span className="icon ">
                  <i className="fab fa-instagram" />
                </span>{' '}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Container>
);
export default Footer;
